import { inject, Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthServiceFacade } from "@pcp/auth";

@Injectable({
    providedIn: 'root',
})
export class AuthGuardGuard implements CanActivate {

    private readonly auth = inject(AuthServiceFacade);


    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.auth.authenticated$;
    }
}
